export const SET_PREDICTION = 'SET_PREDICTION'
export const UPDATE_PREDICTION = 'UPDATE_PREDICTION'
export const DELETE_PREDICTION = 'DELETE_PREDICTION'
export const FETCH_PREDICTIONS = 'FETCH_PREDICTIONS'
export const FETCH_PREDICTION_POINTS = 'FETCH_PREDICTION_POINTS'

